import axios from 'axios'

export default function (context, val) {
    
    let form = context.state.form;
    if (!val && !val.value) {
        context.commit('set_form', {
            ContragentID: '',
            ContragentName: null,
            PartnerLegalEntityId: (form.ContragentType !== 1 && form.ContragentType !== 5) ? null : 0,
        });
    } else {

        context.commit('set_form', {
            ContragentID: val.value,
            ContragentName: val.label,
            PartnerLegalEntityId: null,
        });
        context.state.options.legals = [];
        if (form.ContragentType !== 1 && form.ContragentType !== 5) {
            axios({
                method: 'POST',
                url: '/tourclient/masterAgent/dictionary/partnerData/get',
                data: {request: JSON.stringify({Id: val.value})},
            }).then(r => {
                let main;
                if( r.data.Item.Contracts.length === 0){
                    r.data.Item.PartnerLegals.forEach(i => {
                        if (i.IsMain) main = i.Id;
                        context.state.options.legals.push({
                            contragent: i.PartnerID,
                            value: i.Id,
                            label: i.Name || i.NameFull,
                        });
                    });
                    context.commit('set_form', {
                        PartnerLegalEntityId: main ? main : (context.state.options.legals[0] ? context.state.options.legals[0].value.toString() : null),
                    }); 
                } else {
                    let legalsInContracts = [];
                    r.data.Item.Contracts.forEach(x=>{
                        if (x.PartnerOwnerLegalID){
                            legalsInContracts.push(x.PartnerLegalID);
                        }
                    });

                    if (legalsInContracts.length === 0){
                        r.data.Item.PartnerLegals.forEach(i => {
                            if (i.IsMain) main = i.Id;
                            context.state.options.legals.push({
                                contragent: i.PartnerID,
                                value: i.Id,
                                label: i.Name || i.NameFull,
                            });
                        });
                        context.commit('set_form', {
                            PartnerLegalEntityId: main ? main : (context.state.options.legals[0] ? context.state.options.legals[0].value.toString() : null),
                        }); 

                    } else {
                        r.data.Item.PartnerLegals.forEach(i => {
                            if(legalsInContracts.indexOf(i.Id) !== -1){
                                if (i.IsMain) main = i.Id;
                            context.state.options.legals.push({
                                contragent: i.PartnerID,
                                value: i.Id.toString(),
                                label: i.Name || i.NameFull,
                            });
                            }                            
                        });
                        context.commit('set_form', {
                            PartnerLegalEntityId: main ? main : (context.state.options.legals[0] ? context.state.options.legals[0].value.toString() : null),
                        }); 
                        
                    }                    
                }   

                            
            });
        }
    }
}